namespace GeniuzPOS.Inventory {
    export interface LookupIcGrForTranferLookupRow {
        SysDocNo?: string;
        DocNo?: string;
        WhsIdFm?: string;
        RefDocNo2?: string;
    }

    export namespace LookupIcGrForTranferLookupRow {
        export const idProperty = 'SysDocNo';
        export const nameProperty = 'RefDocNo2';
        export const localTextPrefix = 'Inventory.LookupIcGrForTranferLookup';
        export const lookupKey = 'Inventory.LookupIcGrForTranferLookup';

        export function getLookup(): Q.Lookup<LookupIcGrForTranferLookupRow> {
            return Q.getLookup<LookupIcGrForTranferLookupRow>('Inventory.LookupIcGrForTranferLookup');
        }
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            SysDocNo = "SysDocNo",
            DocNo = "DocNo",
            WhsIdFm = "WhsIdFm",
            RefDocNo2 = "RefDocNo2"
        }
    }
}
